export const formatSpaces = (str) => {
    // after every single letter word replace the space with non breaking space
    return str.replace(/(\s)([a-zA-Z]{1})(\s)/g, "$1$2\u00A0");
};